import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { contractPlanInfo, addContractPlan, editContractPlan } from './../request';
export default {
  data() {
    return {
      paymentDeadline2: {
        way: undefined,
        type: '1',
        value: ''
      },
      dataFrom: {
        duration2: {
          type: undefined,
          value: ''
        }
      },
      paymentDeadlineCont: true,
      paymentDeadline: undefined,
      dataRule: {},
      dialogVisible: false,
      termlist: [{
        id: '1',
        name: '年(单值)'
      }, {
        id: '2',
        name: '年(范围)'
      }, {
        id: '3',
        name: '天(单值)'
      }, {
        id: '4',
        name: '天(范围)'
      }, {
        id: '5',
        name: '终身'
      }],
      rightsList: [{
        name: '',
        value: '',
        info: ''
      }],
      duration1: '',
      duration1Color: true,
      duration2: '',
      duration2Color: true,
      addBtn: true
    };
  },
  methods: {
    init(val) {
      if (val.id) {
        contractPlanInfo({
          contractPlanId: val.id
        }).then(res => {
          console.log(res);
          this.dataFrom = {
            duration2: {
              type: res.duration.type,
              value: ''
            },
            contractId: res.contractId,
            contractPlanId: res.id,
            code: res.code,
            premium: res.premium,
            name: res.name
          };
          if (!res.paymentDeadline.way) {
            this.paymentDeadline2 = {
              way: undefined,
              type: '1',
              value: ''
            };
          } else if (res.paymentDeadline.way == '0') {
            this.paymentDeadline2 = {
              way: '0',
              type: '1',
              value: ''
            };
            this.duration1 = res.duration.value[0];
          } else {
            this.duration1 = res.duration.value[0];
            this.paymentDeadline2 = res.paymentDeadline;
          }
          if (res.duration.value && res.duration.value.length == 2) {
            this.duration2 = res.duration.value[1];
          }
          if (res.rights.length != 0) {
            this.rightsList = res.rights;
            this.InputFun();
          }
        });
      } else {
        this.dataFrom.contractId = val.contractId;
      }
      this.dialogVisible = true;
    },
    handleSure() {
      let type = true;
      if (this.paymentDeadline2.way == 1) {
        if (!this.paymentDeadline2.value) {
          this.paymentDeadlineCont = false;
          // this.$message.error('请完善缴费期限');
          type = false;
        }
      }
      this.paymentDeadline2.value = String(this.paymentDeadline2.value);
      if (!this.duration1 && this.dataFrom.duration2.type) {
        this.duration1Color = false;
        // this.$message.error('请完善保障期限');
        type = false;
      }
      this.dataFrom.duration2.value = String(this.duration1);
      console.log(this.dataFrom.duration2.type == 2 || this.dataFrom.duration2.type == 4, 555);
      if (this.dataFrom.duration2.type == 2 || this.dataFrom.duration2.type == 4) {
        if (!this.duration2) {
          this.duration2Color = false;
          // this.$message.error('请完善保障期限');
          type = false;
        }
        this.dataFrom.duration2.value = String(this.duration1) + ',' + String(this.duration2);
      }
      if (type) {
        console.log(this.dataFrom, 999);
        if (this.paymentDeadline2.way == 0) {
          this.dataFrom.paymentDeadline = JSON.stringify({
            way: '0',
            type: '0',
            value: '0'
          });
        } else {
          if (this.paymentDeadline2.way) {
            this.dataFrom.paymentDeadline = JSON.stringify(this.paymentDeadline2);
          }
        }
        let arr = this.rightsList.filter(item => item.name || item.value || item.info);
        if (arr.length != 0) {
          this.dataFrom.rights = JSON.stringify(arr);
        }
        if (this.dataFrom.duration2.type) {
          this.dataFrom.duration = JSON.stringify(this.dataFrom.duration2);
        }
        let fun = this.dataFrom.contractPlanId ? editContractPlan : addContractPlan;
        fun(this.dataFrom).then(res => {
          this.$message.success(this.$t('操作成功') + '!');
          this.$emit('ok');
          this.$emit('cancel');
        });
      } else {
        this.$message.error(this.$t('请完善信息'));
      }
    },
    onChange(val) {
      // console.log(this.paymentDeadline2.way,55)
      // if(this.dataFrom.paymentDeadline2.way==0){
      //     this.dataFrom.paymentDeadline2={way:0,type:0,value:""}
      // }
      // console.log(val,this.dataFrom.paymentDeadline2)
    },
    onChange2() {
      this.paymentDeadline2.value = '';
      this.paymentDeadlineCont = true;
    },
    onChange3() {
      this.duration2Color = true;
      this.duration1Color = true;
    },
    addRightsFun() {
      this.addBtn = true;
      this.rightsList.push({
        name: '',
        value: '',
        info: ''
      });
    },
    delRightsFun(index) {
      this.rightsList.splice(index, 1);
    },
    InputFun() {
      let arr = this.rightsList.filter(item => item.name || item.value || item.info);
      this.addBtn = arr.length == this.rightsList.length ? false : true;
    }
  }
};